import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import getInterfaceData from './assets/js/getInterfaceData'
import VueAwsomeSwiper from "vue-awesome-swiper"
import axios from "axios"
Vue.use(getInterfaceData)
Vue.use(VueAwsomeSwiper)

/*滚动加载动画*/
import 'animate.css'
import WOW from 'wowjs'
Vue.prototype.$WOW=WOW;

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js